import { createContext } from 'react';
import { noop } from '../../utils/general';
export var TabContext = /*#__PURE__*/createContext({
  activeTabId: undefined,
  onTabClick: noop
});